<script setup>
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { contentAttributes } = useMessageContext();

const actionText = action => {
  if (action.text.startsWith('%')) {
    return t('CHAT_LIST.CARDS.ACTIONS.' + action.text.substring(1));
  }
  return action.text;
};
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="text">
    <div class="gap-3 flex flex-col">
      <div
        v-for="card in contentAttributes.items"
        :key="card.id"
        class="message-text__wrap"
      >
        <div class="text-content">
          <strong>{{ card.title }}</strong>
          <template v-for="action in card.actions">
            <p v-if="action.type === 'link'" :key="action.uri">
              <a
                :href="action.uri"
                class="link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ actionText(action) }}
              </a>
            </p>
          </template>
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
